import { instanceOEF, segundaVersaoOEF } from './api'

export const fazLoginAPI = ( { password, username, captcha } ) => instanceOEF.post( `/auth/`, { password, username, captcha } )

export const verificaTokenAPI = token => instanceOEF.post( `${segundaVersaoOEF}/verificacao-token/`, { token } )
